import { API, graphqlOperation } from "aws-amplify";
import {
  createMonitorAssign,
  deleteMonitorAssign,
  updateMonitorAssign,
} from "graphql/mutations";
import {
  CreateMonitorAssignInput,
  DeleteMonitorAssignInput,
  ListMonitorAssignByInterviewIdQuery,
  ListMonitorAssignByMonitorIdQuery,
  ListMonitorAssignBySubjectIdQuery,
  MonitorAssign,
  UpdateMonitorAssignInput,
} from "types/graphqlapi";
import { GraphQLResult } from "@aws-amplify/api-graphql";
import {
  listMonitorAssignBySubjectId,
  listMonitorAssignByMonitorId,
  listMonitorAssignByInterviewId,
} from "graphql/queries";

/**
 * 同一案件のモニターアサインリストを取得
 * @param subjectId
 * @returns
 */
export const fetchMonitorAssignBysubjectIdQuery = async (subjectId: string) => {
  let list: MonitorAssign[] = [];
  let nextToken = null;

  do {
    const result = (await API.graphql(
      graphqlOperation(listMonitorAssignBySubjectId, {
        subject_id: subjectId,
        limit: 100,
        nextToken,
      })
    )) as {
      data: ListMonitorAssignBySubjectIdQuery;
    };
    const data = result.data.listMonitorAssignBySubjectId;
    const items = (data?.items || []) as MonitorAssign[];
    nextToken = data?.nextToken;

    list = [...list, ...items];
  } while (nextToken);

  return list;
};

/**
 * 同一実査のモニターアサインリストを取得
 * @param interviewId
 * @returns
 */
export const fetchMonitorAssignByInterviewIdQuery = async (
  interviewId: string
) => {
  const result = (await API.graphql(
    graphqlOperation(listMonitorAssignByInterviewId, {
      interview_id: interviewId,
      limit: 10000,
    })
  )) as {
    data: ListMonitorAssignByInterviewIdQuery;
  };

  const list = result.data?.listMonitorAssignByInterviewId
    ?.items as MonitorAssign[];

  return list;
};

/**
 * あるモニターのアサインリストを取得
 * @param monitorId
 * @returns
 */
export const fetchMonitorAssignByMonitorIdQuery = async (
  monitor_id: string
) => {
  let list: MonitorAssign[] = [];
  let nextToken = null;

  do {
    const result = (await API.graphql(
      graphqlOperation(listMonitorAssignByMonitorId, {
        monitor_id,
        nextToken,
      })
    )) as {
      data: ListMonitorAssignByMonitorIdQuery;
    };
    const data = result.data.listMonitorAssignByMonitorId;
    const items = (data?.items || []) as MonitorAssign[];
    nextToken = data?.nextToken;

    list = [...list, ...items];
  } while (nextToken);

  return list;
};

/**
 * あるモニターの最新のアサインリストを取得
 * @param monitorId
 * @returns
 */
export const fetchMonitorLatestAssignByMonitorIdQuery = async (
  moniorId: string
) => {
  const result = (await API.graphql(
    graphqlOperation(listMonitorAssignByMonitorId, {
      monitor_id: moniorId,
    })
  )) as {
    data: ListMonitorAssignByMonitorIdQuery;
  };

  const list = result.data.listMonitorAssignByMonitorId
    ?.items as MonitorAssign[];

  if (list === undefined) return;

  const latestAssign = list.sort((a, b) => {
    if (a.createdAt > b.createdAt) return -1;
    if (a.createdAt < b.createdAt) return 1;
    return 0;
  });

  return latestAssign[0];
};

/**
 * 新規作成
 * @param
 * @returns 作成されたデータ
 */
export const createMonitorAssignMutation = async (
  createMonitorAssignInput: CreateMonitorAssignInput
) => {
  const result = (await API.graphql(
    graphqlOperation(createMonitorAssign, {
      input: createMonitorAssignInput,
    })
  )) as GraphQLResult<{ createMonitorAssign: MonitorAssign }>;

  return result;
};

/**
 * 更新
 * @param
 * @returns 更新されたデータ
 */
export const updateMonitorAssignMutation = async (
  updateMonitorAssignInput: UpdateMonitorAssignInput
) => {
  const result = (await API.graphql(
    graphqlOperation(updateMonitorAssign, {
      input: updateMonitorAssignInput,
    })
  )) as GraphQLResult<{ updateMonitorAssign: MonitorAssign }>;

  return result;
};

/**
 * 特定のデータ削除
 * @param
 * @returns 削除されたデータ
 */
export const deleteMonitorAssignMutation = async (
  deleteMonitorAssignInput: DeleteMonitorAssignInput
) => {
  const result = (await API.graphql(
    graphqlOperation(deleteMonitorAssign, {
      input: deleteMonitorAssignInput,
    })
  )) as GraphQLResult<{ deleteMonitorAssign: MonitorAssign }>;

  return result;
};
